import { useState } from 'react';

import { ButtonCircular } from '@deliveryhero/pd-cookbook/components/ButtonCircular';
import IcThreeDots from '@deliveryhero/pd-cookbook/components/Icons/IcThreeDots';
import { Menu } from '@mui/material';

import { ActionMenuProps } from './types';

export default function ActionMenu({ children }: ActionMenuProps) {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <ButtonCircular
        greyIcon
        aria-label="menu"
        size="small"
        onClick={handleClick}
      >
        <IcThreeDots fontSize="inherit" data-testid="threedots" />
      </ButtonCircular>
      <Menu
        id="demo-positioned-menu"
        aria-labelledby="demo-positioned-button"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 30
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
      >
        {children}
      </Menu>
    </>
  );
}
